export default {
    bjorntech: {
      API_URL_DEV: "https://izettle.finnvid.net/shopify-v1",
      API_URL: "https://izettle.finnvid.net/shopify-v1",
    }
  };